<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-map-scene(
    v-if="props.maptype == store.ui.state.maptype"
    @touchstart="touchstart"
    @mousedown="touchstart"
    :style="sceneStyleObject"
  )
    .l-map-scene__inner
      .l-map-scene__camera(
        :style="cameraStyleObject"
      )
        .l-map-scene__camera__inner
          slot
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-scene
  pos()
  wh(100vw,100vh)
  cursor grab
  &:active
    cursor grabbing
  &__camera
    pos()
    &__inner
      pos(50vw,50vh)


</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent,onMounted, computed ,reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name:'MapScene',

  props:{
    maptype:{
      type:Number,
      default: 1
    }
  },

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const userAction = reactive({
      startX:0,
      startY:0,
      nowX:0,
      nowY:0,
      deltaX:0,
      deltaY:0,
      oldX:0,
      oldY:0,
      touchTime:0,
      deltaTime:0,
      deltaXArr:[],
      deltaYArr:[],
      deltaAveX:0,
      deltaAveY:0,
      tapFingerCount:0,
    })
    // const camera = reactive({
    //   x:0,
    //   y:0,
    //   speedX:0,
    //   speedY:0,
    // })
    const camera = store.ui.state.mapSceneCameras[props.maptype]

    const cameraStyleObject = computed(()=>{
      return {
        left:camera.x + 'px',
        top:camera.y + 'px'
      }
    })
    const sceneStyleObject = computed(()=>{
      return {
        backgroundColor:store.ui.state.seasonColor(store.ui.state.season,store.ui.state.hotoke),
        transition:'background-color 100ms ease ' + store.ui.state.kumoMotionDurationAll + 'ms',
        height:store.browser.state.windowHeight + 'px'
      }
    })

    const touchstart = (e)=>{
      if(e){
        e.preventDefault()
      }
      userAction.tapFingerCount++
      if(e && e.changedTouches && e.changedTouches.length == 2){
        return
      }
      if(e){
        if(e.target.className != 'l-map-item-pin__obj' && store.ui.state.easyinfo.show){
          store.ui.state.easyinfo.show = false
        }
      }
      userAction.startX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX
      userAction.startY = e.changedTouches ? e.changedTouches[0].pageY : e.pageY
      userAction.oldX = userAction.startX
      userAction.oldY = userAction.startY
      userAction.deltaXArr = []
      userAction.deltaYArr = []

      let d = new Date()
      userAction.touchTime = d.getTime()

      if(store.browser.state.isTouch){
        window.addEventListener('touchmove',touchmove,{passive: false})
        window.addEventListener('touchend',touchend,{passive: false})
      } else {
        window.addEventListener('mousemove',touchmove,{passive: false})
        window.addEventListener('mouseup',touchend,{passive: false})
      }
    }
    const touchmove = (e)=>{
      if(e){
        e.preventDefault()
      }
      if(e && e.changedTouches && e.changedTouches.length == 2 || userAction.tapFingerCount == 2){
        return
      }
      userAction.nowX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX
      userAction.nowY = e.changedTouches ? e.changedTouches[0].pageY : e.pageY
      userAction.deltaX = userAction.nowX - userAction.oldX
      userAction.deltaY = userAction.nowY - userAction.oldY
      userAction.oldX = userAction.nowX
      userAction.oldY = userAction.nowY
			userAction.deltaXArr.push(userAction.deltaX)
			userAction.deltaYArr.push(userAction.deltaY)

      let d = new Date()
      userAction.touchTime = d.getTime()

      camera.x = camera.x + userAction.deltaX
      camera.y = camera.y + userAction.deltaY

      // const mapW = 1900 - 460
      // const mapH = 1550 - 220
      const mapW = 1900
      const mapH = 1550
      let limitX = (mapW - store.browser.state.windowWidth) >> 1
      if(limitX < 0 ){
        limitX = 0
      }
      let limitY = (mapH - store.browser.state.windowHeight) >> 1
      if(limitY < 0 ){
        limitY = 0
      }
      if(camera.x > limitX ){
        camera.x = limitX
      }
      if(camera.x < -limitX ){
        camera.x = -limitX
      }
      if(camera.y > limitY ){
        camera.y = limitY
      }
      if(camera.y < -limitY ){
        camera.y = -limitY
      }

    }
    const touchend = (e)=>{
      if(e){
        e.preventDefault()
      }
      userAction.nowX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX
      userAction.nowY = e.changedTouches ? e.changedTouches[0].pageY : e.pageY

			const x1 = userAction.startX
			const y1 = userAction.startY
			const x2 = userAction.nowX
			const y2 = userAction.nowY
			const distance = Math.sqrt( Math.pow( x2-x1, 2 ) + Math.pow( y2-y1, 2 ) )
			if(distance < 5){
        mapClick(e)
      }

      let d = new Date()
      userAction.deltaTime = d.getTime() - userAction.touchTime

      userAction.deltaAveX = 0
      if(userAction.deltaXArr.length > 0){
        let sumX = 0
        userAction.deltaXArr.forEach((v)=>{
          sumX += v
        })
        userAction.deltaAveX = sumX / userAction.deltaXArr.length
      }
			userAction.deltaAveY = 0
      if(userAction.deltaYArr.length > 0){
        let sumY = 0
        userAction.deltaYArr.forEach((v)=>{
          sumY += v
        })
        userAction.deltaAveY = sumY / userAction.deltaYArr.length
      }

      if(store.browser.state.isTouch){
        window.removeEventListener('touchmove',touchmove,{passive: false})
        window.removeEventListener('touchend',touchend,{passive: false})
      } else {
        window.removeEventListener('mousemove',touchmove,{passive: false})
        window.removeEventListener('mouseup',touchend,{passive: false})
      }

      //shift keyを押している間は座標をconsole.logに表示する
      if(store.browser.state.shiftKey){
        let posX = userAction.nowX - store.browser.state.windowWidthHalf - camera.x
        let posY = userAction.nowY - store.browser.state.windowHeightHalf - camera.y
        console.log([posX,posY].join(','))
      }

      userAction.tapFingerCount = 0
      
    }
    const mapClick = (e)=>{
      //PINをクリック
      if(e.target.className == 'l-map-item-pin__obj'){
        if(store.browser.state.responsive == 'pc'){
          //PCの時は直接詳細を開く
          router.push('/article/'+e.target.dataset.id)
        } else {
          //SPの時は簡易情報をはさむ。
          let mapdata = store.api.state.spotsSearchById(e.target.dataset.id);
          store.ui.state.easyinfo.show = true
          store.ui.state.easyinfo.mapdata = mapdata
        }
      }
      //Maptypeボタンをクリック
      if(e.target.className == 'l-map-item-maptypebtn__obj'){
        router.push('/map'+e.target.dataset.to_maptype)
      }
      
    }
    // const update = (e)=>{
    //   if(props.maptype == store.ui.state.maptype){
    //     // console.log('update',props.maptype)
    //   }
    //   window.requestAnimationFrame(update)
    // }
    
    const enter = (el, done)=> {
      if(!store.ui.state.init) done()
      
      camera.x = 0
      camera.y = 0

      $(el).css({zIndex:0,opacity:1})
      $(el).find('.l-map-scene__inner').removeAttr('style')
      done()
    }
    const leave = (el, done)=> {
      if(!store.ui.state.init) done()

      let x = 0
      let y = 0
      let scale = 1.0
      let tl = gsap.timeline()

      if(store.ui.state.maptype > props.maptype){
        const mapdata = store.api.state.mapdataSearchByToMaptype(store.ui.state.maptype , props.maptype)
        if(mapdata){
          const coordinate = mapdata.coordinate.split(",")
          const globalXY = store.ui.state.getMapSceneCameraGLobalXY(coordinate[0],coordinate[1],props.maptype)
          x = globalXY.x * -1
          y = globalXY.y * -1
        }
        scale = 1.2
      } else {
        scale = 0.8
      }
      
      $(el).css({zIndex:1})
      
      let duration1 = store.ui.state.hotoke ? store.ui.state.kumoMotionDurationAll/1000 : store.ui.state.mapytypeMotionDuration1/1000
      
      if(!store.ui.state.hotoke){
        tl.fromTo($(el).find('.l-map-scene__inner'),
          {
            scale:1.0,
          },
          {
            x:x * scale * 0.5,
            y:y * scale * 0.5,
            scale:scale,
            duration:duration1,
            overwrite:false,
            ease:'power1.in',
          }
          ,0.0
        )
      }
      
      tl.to(el,
        {
          opacity:0,
          // duration:store.ui.state.mapytypeMotionDuration2/1000,
          duration:store.ui.state.hotoke ? 1 : duration1 * 0.5,
          ease:'power2.out',
          overwrite:false,
          onComplete:()=>{
            done()
          }
        }
        ,store.ui.state.hotoke ? duration1 : duration1 * 0.5
      )
    }

    onMounted(()=>{
      // update()
    })

    return{
      store,
      props,
      touchstart,
      cameraStyleObject,
      sceneStyleObject,
      enter,
      leave
    }
  }
})
</script>
